<template>
  <div :style="{position: 'relative'}">
    <input
      :id="id"
      ref="autocomplete-input"
      autocomplete="off"
      :disabled="disabled"
      :data="data"
      :class="inputClass"
      :placeholder="placeholder"
      :value="value"
      @input="handleInput($event.target.value)"
      @blur="hideMatchesList"
      @focus="showMatchesList"
      @keypress="showMatchesList"
      @keydown.down="handleSelectionIteration('down')"
      @keydown.up="handleSelectionIteration('up')"
      @keypress.enter.prevent="handleSelection"
    >
    <ul
      v-if="matches.length && value.length && showMatches"
      class="autocomplete-list"
    >
      <li
        v-for="(item, index) in matches"
        :key="item"
        class="list-item"
        :class="{ highlighted: selectedIndex === index }"
        @mouseover="selectedIndex = index"
        @mouseleave="selectedIndex = null"
        @mousedown.prevent="handleClick"
      >
        <span>{{ item }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import matchSorter from 'match-sorter'

export default {

  name: 'AutoComplete',

  props: {
    data: {
      type: Array,
      default: () => []
    },
    id: {
      type: String,
      default: ''
    },
    inputClass: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      showMatches: false,
      selectedIndex: null,
      indexOfThisInputInForm: null
    }
  },
  computed: {
    matches () {
      return matchSorter(this.uniquePages, this.value)
        .filter(item => item !== this.value)
        .slice(0, 5)
    },
    uniquePages () {
      return [...new Set(this.data)]
    }
  },

  // watch: {
  //   index () {
  //     this.indexChanged = true
  //     // because the form could be dynamic, if a field or set of
  //     // fields is removed, we need to recalculate the index of the
  //     // autocomplete input on the dom form. I found a time of 800ms
  //     // was enough to account for animation, added an extra 100ms
  //     // to be sure
  //     setTimeout(() => {
  //       this.indexOfThisInputInForm = this.calculateInputIndex()
  //     }, 900)
  //   }
  // },

  // mounted () {
  //   this.indexOfThisInputInForm = this.calculateInputIndex()
  // },

  updated () {
    // because the form could be dynamic, if a field or set of
    // fields is removed, we need to recalculate the index of the
    // autocomplete input on the dom form, when the form is updated.
    this.$nextTick(() => {
      this.indexOfThisInputInForm = this.calculateInputIndex()
    })
  },

  methods: {
    calculateInputIndex () {
      return [].indexOf.call(
        this.$refs['autocomplete-input'].form,
        this.$refs['autocomplete-input']
      )
    },
    numOfMatches (value) {
      return matchSorter(this.data, value).length
    },
    handleInput (newValue) {
      this.$emit('input', newValue, Boolean(this.matches.length && this.numOfMatches(newValue)))
    },
    handleClick (evt) {
      this.$emit('input', evt.target.innerText)
      this.focusNextInput()
    },
    hideMatchesList () {
      this.showMatches = false
      this.selectedIndex = null
    },
    showMatchesList () {
      this.showMatches = true
    },
    focusNextInput () {
      if (this.$refs['autocomplete-input'].form[this.indexOfThisInputInForm + 1]) {
        this.$refs['autocomplete-input'].form[this.indexOfThisInputInForm + 1].focus()
      }
    },
    handleSelectionIteration (direction) {
      let lastMatchIndex = this.matches.length - 1
      let currentIndex = this.selectedIndex
      if (direction === 'up') {
        this.selectedIndex = currentIndex != null ? currentIndex -= 1 : lastMatchIndex
      } else if (direction === 'down') {
        this.selectedIndex = currentIndex != null ? currentIndex += 1 : 0
      }
      if (currentIndex > lastMatchIndex || currentIndex < 0) {
        this.selectedIndex = null
      }
    },
    handleSelection (evt) {
      if (this.selectedIndex != null) {
        this.$emit('input', this.matches[this.selectedIndex])
        this.hideMatchesList()
      } else {
        this.focusNextInput()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .autocomplete-list {
    position: absolute;
    background-color: white;
    width: 100%;
    font-size: 1.5em;
    border: 1px solid grey;
    z-index: 100;
    border-radius: 5px;

    .list-item {
      padding: 5px;
      display: inline-block;
      width: 100%;

      &.highlighted {
        background-color: #dedede;
      }
    }
  }

</style>